import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-12">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground-900">漫画分类</h2>
        <span className="text-xs text-foreground-500">共{ categories.length }个分类</span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="flex flex-col items-center gap-2 p-4 rounded-lg bg-background-100 hover:bg-primary-50 transition-colors group"
          >
            <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
              <i className={`${cat.icon} text-primary-600 text-lg`}></i>
            </div>
            <span className="text-xs font-medium text-foreground-700 whitespace-nowrap">{cat.name}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}